import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaUser } from "react-icons/fa6";
import { GiExitDoor } from "react-icons/gi";
import { IoMdGrid } from "react-icons/io";
import { useState, useEffect } from 'react';
import { clearLocalStorage } from '../functions/LoginCheck';

import { appFunc, appConfig } from "../functions/FuncHeader";

export default function Navbar({getAppConfig, setAppConfig = () => {}}) 
{
    const location = useLocation();
    const navigate = useNavigate();

    const [isNavOpen, setNavOpen] = useState(false);

    // Forces navbar to close when user is not login (Login Page)
    useEffect(() => {
        if (getAppConfig[appConfig.isUserLogin] === false)
        {
            setNavOpen(false);
        }
        else
        {
            // DO NOTHING
        }
    }, [getAppConfig[appConfig.isUserLogin]])

    return (
        <nav className="nav">
            <div className="nav-title-container">
                <CustomLink to="/" onClick={() => {
                    navigate("/", { replace: true });
                }}>
                    <div className="site-title-initial">
                        <span>蕭</span>
                    </div>
                </CustomLink>
                { 
                    (getAppConfig[appConfig.isUserLogin] === false) ? "" : 
                    <div className={`toggle-button ${isNavOpen ? 'open' : ''}`} onClick={() => setNavOpen(!isNavOpen)}>
                        <span className="bar"></span>
                        <span className="bar"></span>
                        <span className="bar"></span>
                    </div>
                }
            </div>
            <div className = {`nav-expanded ${isNavOpen && getAppConfig[appConfig.isUserLogin] ? "" : "close" }`}>
                <div className={`nav-content-container ${getAppConfig[appConfig.isUserLogin] ? "" : "close"}`}>
                    <div className="navLine" />
                    <div className="nav-content">
                        <CustomLink to="/" onClick={() => {
                            navigate("/", { replace: true });
                        }}>
                            <div className="navLinks">
                                <IoMdGrid />
                                <span>Home</span>
                            </div>
                        </CustomLink>
                    </div>
                    {
                        getAppConfig[appConfig.isUserAdmin] === false ? "" :
                        <div className="nav-content">
                            <CustomLink to="/user-list" onClick={() => {
                                navigate("/user-list", { replace: true });
                            }}>
                                <div className="navLinks">
                                    <FaUser />
                                    <span>Users</span>
                                </div>
                            </CustomLink>
                        </div>
                    }
                    <div className="nav-content">
                        <CustomLink to={location.pathname} onClick={() => {
                            clearLocalStorage();
                            appFunc.updateUseState.object(appConfig.isUserLogin, false, setAppConfig);
                        }}>
                            <div className="navLinks">
                                <GiExitDoor />
                                <span>Logout</span>
                            </div>
                        </CustomLink>
                    </div>
                </div>
            </div>
        </nav>
    );
}

function CustomLink({ to, children, ...props }) {
    return (<Link className="navLink-Container" to={to} {...props}>{children}</Link>)
}